<div class="container">
  <div class="row">
    <div class="col-lg-6 col-md-12" *ngFor="let newsUpdateCard of openNewsTabContentForNewsYear(newsYears[selectedYearIndex])">
      <a class="card cardNews mb-5" href="{{ newsUpdateCard.url }}">
        <div class="row d-flex align-items-stretch">
          <!-- image content -->
          <div class="cardNewsThumb col-12 col-md-4 col-lg-5 order-1 order-md-1">
            <div class="cardNewsThumbWrap">
              <div class="cardNewsThumbWrapContent" [ngStyle]="{ 'background-image': 'url(' + newsUpdateCard.leftImage + ')' }"></div>
              <!-- <img src="{{ newsUpdateCard.leftImage }}" class="cardNewsThumbWrapContent" alt="" /> -->
            </div>
          </div>
          <!-- image content -->
          <!-- content -->
          <div class="col-12 col-md-8 col-lg-7 p-0 order-2 order-md-2 order-1">
            <div class="cardNewsBody">
              <div class="cardNewsBodyContent">
                <h2 class="cardNewsTitle">{{ newsUpdateCard.title }}</h2>
                <p class="">
                  {{ newsUpdateCard.body }}
                </p>
                </div>

              <div class="cardNewsFooter">
                <img alt="" class="post-preview-meta-img" src="{{ newsUpdateCard.footIcon }}" />
                <div>
                  {{ newsUpdateCard.footText | dateFormat }}
                </div>
              </div>
            </div>
          </div>
          <!-- content -->
        </div>
      </a>
    </div>
  </div>
</div>
